import * as React from 'react';
import { getCookie, setCookie } from '../../services/cookies'
import isBrowser from '../../services/isBrowser'
import { Header } from './header'
import { Seo } from './seo'
import { monthSlugsWithOverview } from '../../services/centralStore';
import { Footer } from './footer';
import getDefaultMonthIndex from '../../services/getDefaultMonthIndex';
import { CookieConsent } from './cookie-consent';
import { store } from '../../store/store';
import { Provider } from 'react-redux'
import { locExport, useLoc } from '../../hooks/useLoc';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import weatherSearchSlice, { setLocalization } from '../../store/weatherSearchSlice';
import { useMonth } from '../../hooks/useMonth';
import { ShareButton } from './share';

const globalState = {
    lang: 'en',
    temp: 'C',
    month: monthSlugsWithOverview[getDefaultMonthIndex()]
}

interface LayoutProps {
    children: React.ReactNode,
    title: string,
    description: string,
    showTemperatureSlider?: boolean,
    fadedHeader?: boolean,
    switchTitleOrder?: boolean,
    path: string,
    faqs?: { question: string, answer: string }[],
    month?: string,
    noHeaderFooter?: boolean,
    rootClasses?: string
}

export const Layout = ({ children, title, description, switchTitleOrder, path, faqs, month, noHeaderFooter, rootClasses }: LayoutProps) => {

    const [showCookieConsentBar, setShowCookieConsentBar] = React.useState(false)
    //contexts
    const [language, setLanguage] = React.useState(globalState.lang);
    const [temperatureUnit, setTemperatureUnit] = React.useState(globalState.temp);
    const [activeMonth, setActiveMonth] = React.useState(month || globalState.month);
    //console.log(month, activeMonth)

    React.useEffect(() => {
        //setShowCookieConsentBar(true);
        setShowCookieConsentBar(isBrowser() && !getCookie('cookie_consent') && path.indexOf('cookie-policy') < 0 && path.indexOf('privacy-policy') < 0)
    })
    const globalSetter = (setter, key) => {
        return (newVal) => {
            globalState[key] = newVal;
            setter(newVal);
        }
    }
    //console.log(faqs);
    return (

        <div className={`text-zinc-800 border-zinc-800 h-full relative ${rootClasses}`}>

            <Seo title={title} description={description} path={path} switchTitleOrder={switchTitleOrder} faqs={faqs}></Seo>

            <LanguageContext.Provider value={[language, globalSetter(setLanguage, 'lang')]} >
                <ActiveMonthContext.Provider value={[activeMonth, globalSetter(setActiveMonth, 'month')]} >
                    <TemperatureUnitContext.Provider value={[temperatureUnit, globalSetter(setTemperatureUnit, 'temp')]}>
                        <Provider store={store}>
                            <LayoutInternal>
                                <ShareButton />
                                {!noHeaderFooter && <>
                                    <Header></Header>
                                    <div className="mt-[62px] md:mt-[65px]">{children}</div>
                                    <Footer></Footer>
                                </>}
                                {noHeaderFooter && <>{children}</>}
                                {showCookieConsentBar && <CookieConsent
                                    onAccept={() => { setCookie({ name: 'cookie_consent', value: 1 }); setShowCookieConsentBar(false); }}
                                    onDecline={() => { setCookie({ name: 'cookie_consent', value: 2 }); setShowCookieConsentBar(false); }} />
                                }
                            </LayoutInternal>
                        </Provider>
                    </TemperatureUnitContext.Provider>
                </ActiveMonthContext.Provider>
            </LanguageContext.Provider>

        </div>

    )
}

// here we are able to access contexts and stores
const LayoutInternal = ({ children }: { children: React.ReactNode }) => {
    const loc = useLoc();
    const { month } = useMonth({ ignoreOverview: true });
    const [unit] = React.useContext(TemperatureUnitContext);
    const [lang] = React.useContext(LanguageContext);
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        dispatch(setLocalization(locExport(lang)));
    }, [lang, dispatch]);
    return <>{children}</>
}




export const LanguageContext = React.createContext<[string, (a: string) => void]>([null, (lang) => { }]);
export const ActiveMonthContext = React.createContext<[string, (a: string) => void]>([null, (month) => { }]);
export const TemperatureUnitContext = React.createContext<[string, (a: string) => void]>([null, (units) => { }]);



